import React, { useEffect, useState } from 'react';



export function PRCInput(props) {
    const [inputValue, setInputValue] = useState(props.value);
    


    function handleEvent(method) {
        if (method) {
            method();
        }
    }

    function handleInputChange(e) {
        setInputValue(e.target.value)
    }

    useEffect(() => {
        if(props.value)
        {
            setInputValue(props.value);
        }    
            
    },[props.value, setInputValue]);
    return (
        <>
            <input id={props.id} 
            className={props.className} 
            
            value={inputValue || ''}
             placeholder={props.placeholder} 
             onClick={handleEvent(props.onClick)} 
             onChange={(e) => handleInputChange(e)}
             name={props.name} 
             
             />
        </>

    );
}